import Header from 'app/layout/Header'
import Body from 'app/layout/Body'
import HeaderContext from 'app/HeaderContext'
import PullToRefresh from 'app/components/PullToRefresh'

export default () => {
  const [text, setText] = useState('Dodo')
  const [backPath, setBackPath] = useState(null)
  const [contextualMenu, setContextualMenu] = useState(null)

  const headerContextValue = {
    text,
    setText,
    contextualMenu,
    setContextualMenu,
    backPath,
    setBackPath
  }

  const refresh = useCallback(async () => {
    return new Promise((resolve) => {
      window.location.reload()
    })
  })

  useLayoutEffect(() => {
    if (!isBrowserApp) return
    document.body.classList.add('browser')
  }, [])

  return (
    <HeaderContext.Provider value={headerContextValue}>
      <HashRouter>
        <div id="app" className="bg-grain-02">
          <div className="content">
            <Header text={text} backPath={backPath} />
            <Body />
          </div>
        </div>
      </HashRouter>
    </HeaderContext.Provider>
  )
}
